// extracted by mini-css-extract-plugin
export var label = "_fp-2";
export var slideContainer = "_fp-0";
export var slider = "_fp-1";